import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./doctor.css"
import { Link } from 'react-router-dom';

import Doctorimg from "../../../assets/images/Industry Page/doctors.jpg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Faq from "./faq-doctor";
import Swiper from "../Bfsi Solution/swiper";

import SEO from "../../seo";

export default function Doctor() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
    const CounterOnScroll = ({ end, duration = 2, className }) => {
        const { ref, inView } = useInView({
            triggerOnce: true,
            threshold: 0.3,
        });

        return (
            <span ref={ref}>
                {inView ? (
                    <CountUp end={end} duration={duration} className={className} />
                ) : (
                    <span className={className}>0</span>
                )}
            </span>
        );
    };
    return (
        <div className='product-brand'>
                <SEO
                title="Doctors"
                description="Industries Take Advantage of Hospital/Clinic Software Development At Horizon WebInfo Pvt Ltd, we specialize in crafting bespoke software solutions designed to elevate the healthcare experience. With a deep understanding of the industry&#8217;s intricacies and the power of technology, we bring forth innovative, scalable, and intuitive software applications tailored to meet the unique needs of healthcare [&hellip;]"
                canonical="https://www.hwplindia.com/industries/doctors/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/industries-doctors-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Doctors</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to='/industries'>Industries</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Doctors</li>
                    </ul>
                </div>
            </section>
            <section className='bfsi'>
                <section className="ai-ml-main">
                    <div className='ai-ml-container'>
                        {/* Content Section */}
                        <div className="branding-content">
                            {/* CTA */}
                            <section className="cta-section">
                                <span className='tech'>Industries</span>
                                <h3 className='tech-h3'>Take Advantage of Hospital/Clinic Software Development</h3>
                                <p className='email'>
                                    At Horizon Webinfo Pvt. Ltd. we specialize in crafting bespoke software solutions designed to elevate the healthcare experience. With a deep understanding of the industry’s intricacies and the power of technology, we bring forth innovative, scalable, and intuitive software applications tailored to meet the unique needs of healthcare professionals and patients alike.                                
                                    </p>
                            </section>
                            <section className="Industri-section">
                                <div className="industri-card">
                                    <h3 className="indu-title">Electronic Health Records (EHR) Management</h3>
                                    <p>
                                        <strong>Details:</strong> Create a comprehensive EHR system to digitize patient records, medical history, prescriptions, and treatment plans.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Streamlined information access, reduced paperwork, and improved patient care.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Appointment Scheduling and Calendar Integration</h3>
                                    <p>
                                        <strong>Details:</strong> Implement a user-friendly scheduling system that integrates with calendars, sends reminders, and manages appointment slots.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Efficient appointment management, reduced no-shows, and improved patient punctuality.


                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Prescription Management System</h3>
                                    <p>
                                        <strong>Details:</strong>  Create a Develop a secure system for generating and managing electronic prescriptions, integrating with pharmacies.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Accurate medication tracking, reduced errors, and enhanced prescription security.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Billing and Invoicing Module</h3>
                                    <p>
                                        <strong>Details:</strong> Include a billing system for generating invoices, processing insurance claims, and managing financial transactions.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improved billing accuracy, streamlined payment processes, and enhanced financial management.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Telemedicine and Video Consultation</h3>
                                    <p>
                                        <strong>Details:</strong> Enable telemedicine features for remote consultations, secure video calls, and virtual patient visits.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Increased accessibility, expanded patient reach, and improved healthcare delivery.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Patient Portal for Self-Service</h3>
                                    <p>
                                        <strong>Details:</strong> Develop a patient portal for appointment scheduling, accessing medical records, and communicating with healthcare providers.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Enhanced patient engagement, improved communication, and empowerment for self-management.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Clinical Decision Support System (CDSS)</h3>
                                    <p>
                                        <strong>Details:</strong> Integrate intelligent decision support tools to assist doctors in diagnosis and treatment planning.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Informed decision-making, reduced errors, and improved patient outcomes.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Medical Imaging Integration</h3>
                                    <p>
                                        <strong>Details:</strong> Integrate with medical imaging systems to store, retrieve, and analyze diagnostic images.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Centralized image storage, improved diagnostics, and seamless access to radiological data.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Laboratory Information System (LIS) Integration</h3>
                                    <p>
                                        <strong>Details:</strong> Connect with laboratory systems for efficient test ordering, result retrieval, and data exchange.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Streamlined diagnostic processes, reduced manual errors, and enhanced collaboration with labs.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Secure Messaging and Communication</h3>
                                    <p>
                                        <strong>Details:</strong> Implement secure messaging for communication among healthcare professionals, ensuring patient data confidentiality.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improved collaboration, timely communication, and enhanced patient care coordination.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Patient Education Resources</h3>
                                    <p>
                                        <strong>Details:</strong> Provide educational materials and resources to patients within the software for better health literacy.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Informed patients, improved adherence to treatment plans, and proactive health management.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Health Analytics and Reporting</h3>
                                    <p>
                                        <strong>Details:</strong> Incorporate analytics tools for doctors to track patient health trends, outcomes, and performance metrics.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Data-driven insights, continuous improvement, and evidence-based decision-making.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Mobile Accessibility</h3>
                                    <p>
                                        <strong>Details:</strong> Ensure the software is accessible on mobile devices, facilitating on-the-go access for doctors.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Increased mobility, flexibility in patient care, and improved responsiveness.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Integration with Health Information Exchanges (HIEs)</h3>
                                    <p>
                                        <strong>Details:</strong> Enable interoperability with external healthcare systems for seamless data exchange.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Comprehensive patient data, improved care coordination, and enhanced continuity of care.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                    <section className='bfsi-clor'>
                        <section class="bfsi-section">
                            <div class="bfsi-grid">
                                <div class="bfsi-left">
                                    <h2>
                                       Meet Best Hospital/Clinic Software  
                                       Development Company
                                    </h2>

                                    <p>
                                        Rigorous testing and quality checks are embedded into our development process, ensuring the reliability, performance, and scalability of every solution we deliver. Our commitment extends beyond development. We offer continuous support, updates, and maintenance, ensuring your software remains optimized and functional in the long term.
                                    </p>

                                    <div class="bfsi-stats">
                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={20} duration={2} className="counter" /> +
                                            </h3>
                                            <span>Years Of Experience</span>
                                        </div>

                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={5000} duration={3} className="counter" /> +
                                            </h3>
                                            <span>Happy Customers</span>
                                        </div>

                                    </div>
                                    <span className='elementor-divider-separator'></span>
                                </div>

                                <div class="bfsi-right">
                                    <div class="red-shape"></div>
                                    <img src={Doctorimg} class="bfsi-img" />
                                </div>
                            </div>
                        </section>
                    </section>

                    <Faq />
                    <Swiper />

                </section>
            </section>
        </div>
    );
}